import type { ProductStatus, ProductType } from "@/api/product/_models/Product";

const TYPE_FROM_CIN7: Record<string, ProductType> = {
  Stock: "stock",
  Service: "service",
};
const TYPE_TO_CIN7: Record<ProductType, string> = {
  stock: "Stock",
  service: "Service",
};

const STATUS_FROM_CIN7: Record<string, ProductStatus> = {
  Active: "active",
  "Setup required": "setupRequired",
  Deprecated: "deprecated",
};
const STATUS_TO_CIN7: Record<ProductStatus, string> = {
  active: "Active",
  setupRequired: "Setup required",
  deprecated: "Deprecated",
};

/** Unknown wire values fall back to a sane default rather than throwing. */
export const productTypeFromCin7 = (value: string): ProductType => {
  return TYPE_FROM_CIN7[value] ?? "stock";
};

export const productTypeToCin7 = (type: ProductType): string => {
  return TYPE_TO_CIN7[type];
};

export const productStatusFromCin7 = (value: string): ProductStatus => {
  return STATUS_FROM_CIN7[value] ?? "active";
};

export const productStatusToCin7 = (status: ProductStatus): string => {
  return STATUS_TO_CIN7[status];
};

/** Cin7 stores tags as a comma-delimited string; the domain uses a list. */
export const tagsFromCin7 = (value: string): string[] => {
  return value ? value.split(",").map((t) => t.trim()).filter(Boolean) : [];
};

export const tagsToCin7 = (tags: string[]): string => {
  return tags.join(",");
};
